module.exports = __webpack_public_path__ + "bin/dc70b054835c44211fdf60d2e5f57704.jpg";